import http from '@utils/http';

export const getInterviewOverviewDetail = function (options) {
  return http.post('/api/zhaopin/dingTalk/getInterviewOverviewDetail', options);
};
export const getInterviewArrageDetail = function (options) {
  return http.post('/api/zhaopin/dingTalk/getInterviewArrageDetail', options);
};
export const addInterviewEvaluate = function (options) {
  return http.post('/api/zhaopin/dingTalk/addInterviewEvaluate', options);
};
export const pageList = function (options) {
  return http.post('/api/zhaopin/dingTalk/pageList', options);
};
export const arrageHistoryPageList = function (options) {
  return http.post('/api/zhaopin/dingTalk/arrageHistoryPageList', options);
};
export const getApplyRegsitInfo = function (params) {
  return http.post('/api/zhaopin/dingTalk/getApplyRegsitInfo', params);
};


export function interviewStatistical() {
  return http.post('/api/zhaopin/dingTalk/interviewStatistical', {});
}

export function queryInterview(params) {
  return http.post('/api/zhaopin/dingTalk/queryInterview', params);
}

export function doClaim(params) {
  return http.post('/api/zhaopin/dingTalk/doClaim', params);
}

